import { content } from '../../content';
import { CLOSE_STORE_SELECTION_MODAL_EVENT } from '../../constants';
import { unlockBodyScrollWithCompensation } from '../../utils/scrollbarCompensation';

export const closeModal = () => {
    const foundModal = document.querySelector(`#${content.STORE_CHOOSER.WRAPPER.id}`);

    if (foundModal) {
        foundModal.classList.remove(content.STORE_CHOOSER.WRAPPER.visibleClass);
    }

    // Use enhanced scroll unlock with scrollbar compensation
    unlockBodyScrollWithCompensation(content.CLASSNAMES.bodyScrollLock);

    var event = new CustomEvent(CLOSE_STORE_SELECTION_MODAL_EVENT);
    document.documentElement.dispatchEvent(event);
}
